<script>
	const defaultCity = 'Porto Alegre';
	export let selectedNegotiationType = '8';
	export let hideNegotiationType = false;
	// let selectedNegotiationType = '1';
	let selectedRealtytype = '';
	let selectedCity = defaultCity;
	let selectedNeighborhoods = '';
	let selectedBedrooms = '';
	let selectedParkingSpots = '';
	let selectedCode = '';
	let selectedPriceMin = 0.0;
	let selectedPriceMax = 0.0;
	let selectedPriceFull = false;
	let selectedFeatures = '';

	if (GetHash('tipo_negociacao') != null) {
		selectedNegotiationType = GetHash('tipo_negociacao');
	}

	if (GetHash('tipo_imovel') != null) {
		selectedRealtytype = GetHash('tipo_imovel');
	}

	if (GetHash('cidade') != null) {
		selectedCity = GetHash('cidade');
	}

	if (GetHash('bairros') != null) {
		selectedNeighborhoods = GetHash('bairros');
	}

	if (GetHash('dormitorios') != null) {
		selectedBedrooms = GetHash('dormitorios');
	}

	if (GetHash('vagas') != null) {
		selectedParkingSpots = GetHash('vagas');
	}

	if (GetHash('codigon') != null) {
		selectedCode = GetHash('codigon');
	}

	if (GetHash('valor_de') != null) {
		selectedPriceMin = GetHash('valor_de');
	}

	if (GetHash('valor_ate') != null) {
		selectedPriceMax = GetHash('valor_ate');
	}

	if (GetHash('valor_completo') != null) {
		selectedPriceFull = GetHash('valor_completo');
	}

	if (GetHash('recursos') != null) {
		selectedFeatures = GetHash('recursos');
	}

	$: price_range = selectedPriceMin > 0 && selectedPriceMax <= 0 ? `A partir de R$ ${atria.formatMoney(selectedPriceMin)}` : (selectedPriceMin <= 0 && selectedPriceMax > 0 ? `Até R$ ${atria.formatMoney(selectedPriceMax)}` : (selectedPriceMin > 0 && selectedPriceMax > 0 ? `${atria.formatMoney(selectedPriceMin)} - ${atria.formatMoney(selectedPriceMax)}` : 'Faixa de valor'));

	export let style = 'internas';
	export let buttonClass = 'btn-secondary';

	import { createEventDispatcher, afterUpdate } from 'svelte';

	const dispatch = createEventDispatcher();
	
	function updatePriceRange() {
		if (selectedPriceMin <= 0) {
			selectedPriceMin = 0;
		}
		if (selectedPriceMax <= 0) {
			selectedPriceMax = 0;
		}
		if (selectedPriceMax > 0 && selectedPriceMax < selectedPriceMin) {
			selectedPriceMax = 0;
		}
	}

	function negotiationTypeChange() {
		selectedRealtytype = '';
		selectedCity = defaultCity;
		selectedNeighborhoods = '';
		selectedPriceMin = 0;
		selectedPriceMax = 0;
		selectedPriceFull = false;
	}
	function cityChange() {
		selectedNeighborhoods = '';
	}
	function search() {
		dispatch('filter', {
			tipo_negociacao: selectedNegotiationType,
			tipo_imovel: selectedRealtytype, 
			cidade: selectedCity, 
			bairros: selectedNeighborhoods,
			dormitorios: selectedBedrooms,
			vagas: selectedParkingSpots,
			codigon: selectedCode,
			valor_de: selectedPriceMin,
			valor_ate: selectedPriceMax,
			valor_completo: selectedPriceFull?'1':'0',
			recursos: selectedFeatures
		});
	}

	async function getRealtyTypes(nt) 
	{
		let response = await fetch(`${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=realtytype&nt=${nt}&callback=null`,{
			method: 'GET',
			mode: 'cors'
		});
		let data = await response.json()
		return data;
	}
	async function getCidades(nt) 
	{
		let response = await fetch(`${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=city&nt=${nt}&callback=null`,{
			method: 'GET',
			mode: 'cors'
		});
		let data = await response.json()
		return data;
	}
	async function getResources(nt) 
	{
		if (selectedNegotiationType == 8) {
			return [{K:'mobiliado', D:'Mobiliado'}];//,{K:'freire', D:'Somente imóveis Freire'}];
		} else {
			return [{K:'mobiliado', D:'Mobiliado'}];
		}
	}
	
	$: neighborhoods = [];
	$: realtytypes = getRealtyTypes(selectedNegotiationType).then(json => json.Items);
	$: cities = getCidades(selectedNegotiationType).then(json => {
		if (selectedCity != '') {
			neighborhoods = json.Items.find(c=>c.City === selectedCity).Neighborhoods;
		} else {
			neighborhoods = [];
		}
		return json.Items
	});
	$: resources = getResources(selectedNegotiationType).then(json => json);

	afterUpdate(() => { 
		setTimeout(() => jQuery('.searchbar .selectpicker').selectpicker(), 500);        
	});
</script>

<nav class="searchbar searchbar--{style}">
	<form on:submit|preventDefault={search}>
		<div class="form-row">
			<div class="item col col--tipodenegociacao internas-only">
				<div class="form-group">
					<select disabled={hideNegotiationType} data-dropup-auto="false" class="selectpicker w-100" bind:value={selectedNegotiationType} on:change={negotiationTypeChange}>
						<option value="8">Comprar</option>
						<option value="1">Alugar</option>
					</select>
				</div> 
			</div>
			<div class="item col col--tiposdeimoveis">
				{#await realtytypes}
					<div class="form-group multiple">
						<select data-dropup-auto="false" class="selectpicker w-100" multiple title="Tipo do imóvel" data-selected-text-format="count" data-live-search="true">
							<option value="">Carregando ...</option>
						</select>
					</div> 
				{:then data}
					<div class="form-group multiple">
						<select data-dropup-auto="false" class="selectpicker w-100" multiple title="Tipo do imóvel" data-selected-text-format="count" data-live-search="true" bind:value={selectedRealtytype}>
							{#each data as realtytype}
								<option value={realtytype.Key}>{realtytype.Value}</option>
							{/each}
						</select>
					</div>
				{/await}      
			</div>
			{#await cities}
				<div class="item col col--cidades">
					<div class="form-group">
						<select data-dropup-auto="false" class="selectpicker w-100">
							<option value="">Carregando ...</option>
						</select>
					</div>         
				</div>
				<div class="item col col--bairros internas-only">
					<div class="form-group">
						<select data-dropup-auto="false" class="selectpicker w-100" multiple title="Bairros" data-selected-text-format="count" data-live-search="true">
							<option value="">Carregando ...</option>
						</select>
					</div>         
				</div>
			{:then data}
				<div class="item col col--cidades">
					<div class="form-group">
						<select data-dropup-auto="false" class="selectpicker w-100" bind:value={selectedCity} on:change={cityChange} data-live-search="true">
							<option value="">Cidade</option>
							{#each data as city}
								<option value={city.City}>{city.City} - {city.State}</option>
							{/each}
						</select>
					</div>   
				</div>
				<div class="item col col--bairros internas-only">
					<div class="form-group multiple">
						<select data-dropup-auto="false" class="selectpicker w-100" multiple title="Bairros" data-header="Bairros" data-selected-text-format="count" data-live-search="true" bind:value={selectedNeighborhoods}>
							{#each neighborhoods as neighborhood}
								<option>{neighborhood}</option>
							{/each}
						</select>
					</div>
				</div>
			{/await}
			<div class="item col col--dormitorios internas-only">
				<div class="form-group">
					<select class="selectpicker w-100" bind:value={selectedBedrooms}>
						<option value="">Dormitórios</option>
						<option value="1,2,3,4,5,6,7,8,9,10">1+ Dormitórios</option>
						<option value="2,3,4,5,6,7,8,9,10">2+ Dormitórios</option>
						<option value="3,4,5,6,7,8,9,10">3+ Dormitórios</option>
						<option value="4,5,6,7,8,9,10">4+ Dormitórios</option>
						<option value="5,6,7,8,9,10">5+ Dormitórios</option>
					</select>            
				</div> 
			</div>
			<div class="item col col--vagas internas-only">
				<div class="form-group">
					<select class="selectpicker w-100" bind:value={selectedParkingSpots}>
						<option value="">Vagas</option>
						<option value="1,2,3,4,5,6,7,8,9,10">1+ Vagas</option>
						<option value="2,3,4,5,6,7,8,9,10">2+ Vagas</option>
						<option value="3,4,5,6,7,8,9,10">3+ Vagas</option>
						<option value="4,5,6,7,8,9,10">4+ Vagas</option>
						<option value="5,6,7,8,9,10">5+ Vagas</option>
					</select>            
				</div> 
			</div>
			<div class="item col col--faixadevalor">
				<div class="form-group">        
					<div class="w-100 bootstrap-select dropdown">
						<a type="button" class="btn dropdown-toggle btn-light" data-display="static" data-toggle="dropdown" role="button" title="{price_range}" aria-haspopup="true" aria-expanded="false" style="margin:0px">
							{price_range}
						</a>
						<div class="dropdown-menu pl-1 pr-1 pb-2">
							<div class="clearfix pl-10 pr-10 pb-10">
								<label><b>De:</b></label>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text round-left background-secondary color-white border-secondary">R$</span>
									</div>
									<input bind:value={selectedPriceMin} step="100" type="number" class="form-control round-left-none" placeholder="De" on:change={updatePriceRange} />
								</div>
								<label><b>Até:</b></label>
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text round-left background-secondary color-white border-secondary">R$</span>
									</div>
									<input bind:value={selectedPriceMax} step="100" type="number" class="form-control round-left-none" placeholder="Até" on:change={updatePriceRange} />
								</div>
								<div class="form-group-price hide">
									<label><input type="checkbox" bind:value={selectedPriceFull} /> incluir valor de condomínio e IPTU</label>
								</div>
							</div>
						</div>
					</div>               
				</div>
			</div>
			{#await resources}
			<div class="item col col--recursos internas-only">
				<div class="form-group">
					<select data-dropup-auto="false" class="selectpicker w-100">
						<option value="">Carregando ...</option>
					</select>
				</div>         
			</div>
			{:then data}
			<div class="item col col--recursos internas-only">
				<div class="form-group">
					<select data-dropup-auto="false" class="selectpicker w-100" title="Recursos" data-header="Recursos" multiple bind:value={selectedFeatures}>
						{#each data as recurso}
						<option value={recurso.K}>{recurso.D}</option>
						{/each}
					</select>            
				</div> 
			</div>
			{/await}
			<div class="item col col--codigo">
				<div class="form-group">
					<input type="text" class="form-control input-custom" placeholder="Código" bind:value={selectedCode} />
				</div> 
			</div>
			<div class="item col col--buscar">
				<button class="btn {buttonClass} w-100" on:click={search}><b>BUSCAR</b></button>
			</div>
		</div>
	</form>
</nav>

<style type="text/sass">

@import 'public/assets/sass/variables.sass'

.form-group 
	width: 100%
	margin: 5px
	.form-control
		padding: 15px 6%
		font-size: $font-text
		+transition(box-shadow 0.8s ease)
		&:hover 
			+box-shadow($color-shadow--default)
	+media-breakpoint-down(md) 
		min-width: 150px

.searchbar 
	padding: 20px 0
	position: relative
	z-index: 99
	.item 
		font-size: $font-text
		+media-breakpoint-up(xl) 
			&:last-child
				max-width: 400px
	.btn
		margin: 5px
		span
			color: #fff 
	.form-group 
		margin: 5px

.btn-light
	background-color: #fff

.input-group-text
	padding: 0px 5px
	font-size: 14px

.form-group-price
	font-size: 14px

.input-custom
	padding: 16px 20px !important
	text-transform: uppercase
	font-size: $font-text !important
	font-weight: bold !important
	box-shadow: inset 0 1px 0 rgba(255,255,255,0.15), 0 1px 1px rgba(0,0,0,0.075)

.searchbar--home .internas-only
	display: none
</style>